// Bare timer globals rather than `window.*` — React Native has no `window`, and this runs
// on both platforms.
export const debounce = <Callback extends (...args: never[]) => unknown>(
  callback: Callback,
  timeout = 500,
) => {
  let timer: ReturnType<typeof setTimeout>;

  return (...args: Parameters<Callback>) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback(...args), timeout);
  };
};
